import { HeaderHLPure, SimpleLoading } from '../../pures'
import { Container, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { TokenVolumeGraph, StatCard, SimpleCard, ExpenseSpeedometer } from '../../pures/dashboard'
import { DropDownList } from "@progress/kendo-react-dropdowns"

const UsageView = (props) => {
    const {
        isLoading,
        usagePart1,
        dailyTokenUsage,
        date,
        handleChangeDate,
        monthYearOptions
    } = props

    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' })

    const buildPlanModelValue = () => {
        const planLabel = usagePart1?.name || 'N/D'
        const modelLabel = usagePart1?.iaModel || 'N/A'

        if (usagePart1?.planModelLabel) {
            const parts = usagePart1.planModelLabel.split('+').map(part => part.trim())

            if (parts.length >= 2) {
                return (
                    <>
                        <span>{parts[0]}</span>
                        <br />
                        <span className='small-value'>{parts.slice(1).join(' + ')}</span>
                    </>
                )
            }
        }

        return (
            <>
                <span>{planLabel}</span>
                <br />
                <span className='small-value'>{modelLabel}</span>
            </>
        )
    }

    const formatCompactNumber = (value) => {
        const num = Number(value)
        if (!Number.isFinite(num)) return 'N/A'
        if (Math.abs(num) >= 1_000_000) return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, '') + 'M'
        if (Math.abs(num) >= 1_000) return (num / 1_000).toFixed(2).replace(/\.?0+$/, '') + 'K'
        return num.toString()
    }

    const parseNumericValue = (value) => {
        if (typeof value === 'number') return value
        if (typeof value === 'string') {
            const normalized = value.replace(/,/g, '').trim()
            const parsed = Number(normalized)
            return Number.isFinite(parsed) ? parsed : null
        }
        return null
    }

    const monthTotalConversations = Object.values(dailyTokenUsage?.dailyUsage || {}).reduce((acc, dayValue) => {
        return acc + (parseNumericValue(dayValue) || 0)
    }, 0)

    const backendTotalConversations = parseNumericValue(usagePart1?.totalConversationsUsedInAverage)
    const backendMonthlyAverage = parseNumericValue(usagePart1?.monthlyAverageElapsedDays)

    const hasNoActivity = !backendTotalConversations || backendTotalConversations <= 0

    const effectiveMonthlyAverage = hasNoActivity ? 0 : backendMonthlyAverage

    return (
        <>
            {isLoading
                ? <div className='loading'>
                    <SimpleLoading />
                </div>
                : (<div className={"dashboardView"}>
                    <Container>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <HeaderHLPure title={t("title")} />
                            </Grid>
                            
                            <Grid container item xs={16} spacing={1} className="reportsAndStatisticsView-dashboard">
                                <Grid item xs={16} md={2}>
                                    <SimpleCard 
                                        title={t('usagePeriod')}
                                    >
                                        <DropDownList
                                        id='assistantTone'
                                        name={'assistantTone'}
                                        className="eticket-dropdown-field"
                                        textField="text"  
                                        dataItemKey="value"
                                        data={monthYearOptions}
                                        value={monthYearOptions.find(option => option.value === date)}
                                        onChange={handleChangeDate}
                                    />
                                    </SimpleCard>
                                </Grid>
                                
                                <Grid item xs={16} md={2}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("name")}
                                        value={buildPlanModelValue()}
                                    />
                                </Grid>
                                
                                <Grid item xs={16} md={4}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("tokensVsPlan")}
                                        value={
                                            <>
                                                <span>{formatCompactNumber(usagePart1?.tokensConsumed ?? 0)}</span>
                                                <span className='small-value'> / {usagePart1?.tokensPlan != null ? formatCompactNumber(usagePart1.tokensPlan) : 'N/A'}</span>
                                            </>
                                        }
                                    />
                                </Grid>
                                
                                <Grid item xs={16} md={3}>
                                    <StatCard
                                        className={'textCard'}
                                        title={t("averagePerDay")}
                                        value={hasNoActivity ? 0 : usagePart1.dailyAverageConversations}
                                    />
                                </Grid>
                            </Grid>

                            {/* Segunda fila: TokenVolumeGraph */}
                            <Grid item xs={16} md={9} className="rasd-graph">
                                <SimpleCard>
                                    <p class='dashboardView-card-title'>{t('tokenGraphTitle')}</p>
                                    <TokenVolumeGraph
                                        data={dailyTokenUsage}
                                        monthlyAverage={effectiveMonthlyAverage}
                                        t={t}
                                    />
                                </SimpleCard>
                            </Grid>

                            <Grid item xs={16} md={3} className="rasd-speedometer">
                                <SimpleCard style={{ height: '100%' }}>
                                    <ExpenseSpeedometer data={usagePart1} t={t} />
                                </SimpleCard>
                            </Grid>
                        </Grid>
                    </Container>
                </div>)
            }
        </>
    )
}

export { UsageView as default }